'use client';

export { GlobalErrorPageSport as default } from '@svs/nova-foundation/nextjs/pages';
